import { takeLatest, put } from "redux-saga/effects";
import { FETCH_SasData_REQUEST, REDIRECT_TO_LOGIN } from "./actionsTypes";
import {
  fetchSasDataSuccess,
  FETCH_SasData_FAILURE,
  redirectToLogin,
} from "./actions";
import axios from "axios";
import Config from "config";
function* fetchSasData(action) {
  // const { token} = action.payload;
  const token = localStorage.getItem("auth_token");
  const api = Config.backOffice.apiName;
  try {
    const response = yield axios.get(
      `https://www.fluxod.com/${api}/fdashboards/widget_sas_en_attente`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    yield put(fetchSasDataSuccess(response.data));
  } catch (error) {
    // yield put(fetchListFailure(error));
    yield put({ type: REDIRECT_TO_LOGIN });
  }
}

function* sasDataSaga() {
  yield takeLatest(FETCH_SasData_REQUEST, fetchSasData);
}

export default sasDataSaga;
